<script>
import Vue from 'vue'
import {mapActions} from "vuex";

export default Vue.extend({
  name: "referredClientsTable",
  data() {
    return {
      referredClients: [],
      referredClientsAdditional: [],
      totalReferredClients: 0,
      pageReferredClients: 1,
      sizeReferredClients: 25,
      moreDetailsDialog: false,
      agentNotes: {},
      agentNotesHistory: {},
    }
  },
  methods: {
    ...mapActions("enquiry", ["getReferredClients", "getConciergeReferralAgentNotes", "createConciergeReferralAgentNoteRecord"]),

    retrieveReferredClientList() {
      let params = {
        page: this.pageReferredClients,
        size: this.sizeReferredClients,
      }
      this.getReferredClients({params: params, callback: this.callback})
    },
    processClientAddress(value) {
      if (value.address && value.suburb && value.postcode && value.state) {
        return value.address + ' ' + value.suburb + ' ' + value.postcode + ' ' + value.state;
      }
      return 'N/A';
    },
    processClientFullName(value) {
      if (value.title && value.firstName && value.surname) {
        return value.title + ' ' + value.firstName + ' ' + value.surname;
      }
      return 'N/A';
    },
    handleCurrentChange(val) {
      this.pageReferredClients = val
      this.retrieveReferredClientList()
    },
    showDetail(key, val) {
      if (key == 1) {
        this.$router.push({path: '/uconnect/view', query: {pid: val.propertyId}})
      }
    },
    moreDetailsOnReferredClient(row) {
      this.moreDetailsDialog = true;
      this.referredClientsAdditional = row;
    },
    truncateQuestion(value) {
      if (value && value.length > 25) {
        return value.substring(0, 25) + '...';
      }
      return value;
    },
    processPropertyAddress(value) {
      if (value.propertyAddress && value.propertySuburb && value.propertyPostcode && value.propertyState) {
        return value.propertyAddress + ' ' + value.propertySuburb + ' ' + value.propertyPostcode + ' ' + value.propertyState;
      }
      return 'N/A';
    },
    callback(resp, status) {
      switch (status) {
        case 'getReferredClientsCallback':
          if (resp.code == 0) {
            this.totalReferredClients = resp.data.totalRecord
            this.referredClients = resp.data.list
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        case 'createConciergeReferralAgentNoteRecordCallback':
          if (resp.code == 0) {
            this.$message.success('Note added successfully');
            const contactId = resp.data;
            if (contactId && this.agentNotes[contactId]) {
              this.$set(this.agentNotes, contactId, '');
            }
            if (contactId) {
              this.fetchAgentNotesForContact(contactId);
            }
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        case 'getConciergeReferralAgentNotesCallback':
          if (resp.code === 0) {
            const allNotesList = Array.isArray(resp.data) ? resp.data : [];
            const notesByContact = {};
            allNotesList.forEach(note => {
              const cId = note.referClientId;
              if (cId) {
                if (!notesByContact[cId]) {
                  notesByContact[cId] = [];
                }
                notesByContact[cId].push(note);
              }
            });
            Object.keys(notesByContact).forEach(contactId => {
              this.$set(this.agentNotesHistory, String(contactId), notesByContact[contactId]);
              this.$set(this.agentNotesHistory, Number(contactId), notesByContact[contactId]);
            });
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        default:
          break;
      }
    },
    formatCurrency(value) {
      if (value === null || value === undefined || isNaN(Number(value))) {
        return 'N/A';
      }
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
      }).format(value);
    },
    onExpandChange(row, expandedRows) {
      if (row.contactId && expandedRows.some(r => r.contactId === row.contactId)) {
        this.fetchAgentNotesForContact(row.contactId);
      }
    },
    fetchAgentNotesForContact(contactId) {
      let params = {
        contactId: contactId,
      }
      this.getConciergeReferralAgentNotes({params: params, callback: this.callback})
    },
    addNote(contactId) {
      const note = this.agentNotes[contactId];
      if (!note || !note.trim()) {
        this.$message.error('Please enter agent note');
        return false;
      }

      let params = {
        referClientId: contactId,
        note: note,
      }
      this.createConciergeReferralAgentNoteRecord({params: params, callback: this.callback})
    },
    rowStyle({row, rowIndex}) {
      if (rowIndex === 0) {
        return {
          backgroundColor: '#d4edda'
        }
      }
      return {}
    }
  },
  mounted() {
    this.retrieveReferredClientList()
  },
})
</script>

<template>
  <div>
    <el-table
      :data="referredClients"
      style="width: 100%;"
      @expand-change="onExpandChange">
      <el-table-column type="expand">
        <template v-slot="scope">
          <div style="padding: 10px; background-color: #f3eeee;">
            <!-- First Row: Agent Notes -->
            <el-row :gutter="10" type="flex">
              <el-col :span="8">
                <div class="info-item">
                  <div class="info-label">
                    <i class="el-icon-notebook-2"></i> Agent Notes
                  </div>
                  <el-form
                    label-position="top"
                    label-width="100px"
                    @submit.native.prevent
                    style="font-family: DINosaur-a, sans-serif;">
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Agent Note">
                          <el-input type="textarea" rows="3" placeholder="Agent notes" v-model="agentNotes[scope.row.contactId]" maxlength="100" show-word-limit></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-button class="add-note-btn" icon="el-icon-plus" @click="addNote(scope.row.contactId)">Add Note</el-button>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="info-item">
                  <div class="info-label">Agent Note History</div>
                  <div class="info-content" style="display: block; width: 100%;">
                    <el-table
                      v-if="Array.isArray(agentNotesHistory[scope.row.contactId]) && agentNotesHistory[scope.row.contactId].length > 0"
                      class="compact-table"
                      :data="agentNotesHistory[scope.row.contactId]"
                      height="200"
                      :row-style="rowStyle"
                      style="width: 100%">
                      <el-table-column
                        prop="created"
                        label="Date"
                        width="180">
                      </el-table-column>
                      <el-table-column
                        label="Channel Partner"
                        width="180">
                        <template v-slot="innerScope">
                          <span>{{ innerScope.row.cpFirstName + ' ' + innerScope.row.cpLastName }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="note"
                        label="Note">
                      </el-table-column>
                    </el-table>
                    <div v-else style="padding: 10px; text-align: center;">
                      <span class="empty-text">No notes available</span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="commission"
        min-width="40"
        align="center"
        label="">
        <template v-slot="scope">
            <el-tag v-if="scope.row.lessCommission" size="mini" type="danger" effect="dark">{{ scope.row.commission }}%</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="clientName"
        min-width="130"
        label="Client Name">
      </el-table-column>
      <el-table-column
        prop="contactNumber"
        min-width="150"
        label="Contact Number">
      </el-table-column>
      <el-table-column
        prop="email"
        min-width="150"
        label="Email">
      </el-table-column>
      <el-table-column
        prop="propertyId"
        min-width="150"
        label="Property Address">
        <template v-slot="scope">
          <span>{{ processPropertyAddress(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="clientBudget"
        min-width="150"
        label="Client Budget">
        <template v-slot="scope">
          <span>{{ formatCurrency(scope.row.clientBudget) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="reason"
        min-width="150"
        label="Reason">
        <template v-slot="scope">
          <span>{{ truncateQuestion(scope.row.reason) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="comment"
        min-width="150"
        label="Comment">
        <template v-slot="scope">
          <span>{{ truncateQuestion(scope.row.comment) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="created"
        min-width="200"
        label="Date">
        <template v-slot="scope">
          <span>{{ scope.row.created }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="propertyId"
        min-width="200"
        label="Actions">
        <template v-slot="scope">
          <el-button class="btn-link" @click="moreDetailsOnReferredClient(scope.row)" type="text" icon="el-icon-more-outline">More
          </el-button>
          <span class="divider"> | </span>
          <el-button class="btn-link" @click="showDetail(1,scope.row)" type="text" icon="el-icon-view">View
            Property
          </el-button>
<!--          <span class="divider"> | </span>-->
<!--          <el-button class="btn-link" @click="handleDelete(scope.row)" type="text" icon="el-icon-delete">Remove-->
<!--          </el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="fen" v-if="totalReferredClients">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageReferredClients"
        :page-size="25"
        layout="total, prev, pager, next"
        :total="totalReferredClients">
      </el-pagination>
    </div>

    <!-- More Details Dialog -->
    <el-dialog
      title="Referred Client Details"
      :visible.sync="moreDetailsDialog"
      :append-to-body="true"
      class="referred-client-dialog"
      :show-close="false"
      center
      width="500px">
      <template v-slot class="dialog-body">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Client Name: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.clientName }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Contact Number: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.contactNumber }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Email: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.email }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Your Name: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.yourName }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Client Budget: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ formatCurrency(referredClientsAdditional.clientBudget) }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Client Name: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.clientName }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Reason: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.reason }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Comment: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.comment }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="24" style="text-align: center; padding: 20px 0 5px 0">
                <span style="font-weight: 600; font-size: 16px">Client Details for the Reservation</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Name: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ processClientFullName(referredClientsAdditional) }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Address: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ processClientAddress(referredClientsAdditional) }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Email: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.emailAdditional ? referredClientsAdditional.emailAdditional : 'N/A' }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding: 3px 0">
              <el-col :span="8" style="text-align: right">
                <span>Phone: </span>
              </el-col>
              <el-col :span="16" style="text-align: left">
                <span style="font-weight: 600">{{ referredClientsAdditional.phone ? referredClientsAdditional.phone : 'N/A' }}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </template>
      <template v-slot:footer class="dialog-footer">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button type="primary" @click="moreDetailsDialog = false"
                       style="background:#003333;border:none;width:100%;">Close
            </el-button>
          </el-col>
        </el-row>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.btn-link {
  color: rgba(0, 51, 51, 0.9);
  font-family: 'DINosaur-a', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
}

.btn-link:hover {
  color: #003333;
}

.referred-client-dialog .el-dialog__header {
  padding: 10px !important;
}
.referred-client-dialog .el-dialog__title {
  font-size: 24px;
}

.info-item {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 10px;
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.info-label {
  font-size: 13px;
  font-weight: 600;
  color: #909399;
  margin-bottom: 4px;
}

.info-label i {
  margin-right: 4px;
}

.info-content {
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 5px;
}
.empty-text {
  color: #C0C4CC;
  font-style: italic;
}
.text-i {
  font-style: italic;
}
.add-note-btn {
  font: 500 12px DINosaur-a, sans-serif;
  border: 3px solid #003333;
  color: #ffffff;
  background-color: #003333;
  padding: 10px 0;
  cursor: pointer;
  width: 100%;
}

.compact-table >>> .el-table__header th,
.compact-table >>> .el-table__body td {
  padding: 2px 0 !important; /* Reduce vertical padding */
  height: 30px !important;   /* Set fixed row height */
}

.compact-table >>> .el-table__header th {
  font-size: 14px;
}

.compact-table >>> .el-table__body td {
  font-size: 14px;
}

.el-table >>> .first-row-green {
  background-color: #d4edda !important;
}

.el-table >>> .first-row-green:hover {
  background-color: #21873a !important;
}

.el-table >>> .first-row-green:hover > td {
  background-color: #4d66ca !important;
}
</style>



// WEBPACK FOOTER //
// src/components/enquiry/referredClientsTable.vue